var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06001 8.27245C5.45054 7.88192 6.0837 7.88192 6.47423 8.27245L12 13.7982L17.5258 8.27245C17.9163 7.88192 18.5495 7.88192 18.94 8.27245C19.3305 8.66297 19.3305 9.29614 18.94 9.68666L13.0507 15.5759C12.9176 15.7138 12.7578 15.825 12.58 15.902C12.5798 15.9021 12.5796 15.9022 12.5793 15.9022L12.1829 14.9842L12.5807 15.9017C12.5805 15.9018 12.5802 15.9019 12.58 15.902C12.3963 15.9815 12.1989 16.0221 12 16.0221C11.8009 16.0221 11.6032 15.9814 11.4193 15.9017L11.8171 14.9842L11.4206 15.9022C11.2426 15.8253 11.0826 15.714 10.9493 15.5759L10.9573 15.5839L11.6644 14.8768L10.9354 15.5614C10.94 15.5663 10.9446 15.5711 10.9493 15.5759L5.06001 9.68666C4.66949 9.29614 4.66949 8.66297 5.06001 8.27245Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ChevronDown.639a4afa99fa5c0fa5e6892d98c5bd68.svg";